import { createAuthClient } from 'better-auth/react'
import { twoFactorClient, phoneNumberClient } from 'better-auth/client/plugins'
import i18n, { DEFAULT_LANGUAGE } from '../i18n'

const apiBaseUrl = (import.meta.env.VITE_API_URL ?? '').trim()
const authBaseUrl = import.meta.env.DEV
  ? window.location.origin
  : apiBaseUrl

function getAcceptLanguage(): string {
  return i18n.language?.split('-')[0] || DEFAULT_LANGUAGE
}

export const authClient = createAuthClient({
  baseURL: authBaseUrl,
  plugins: [twoFactorClient(), phoneNumberClient()],
  fetchOptions: {
    onRequest: (context) => {
      context.headers.set('Accept-Language', getAcceptLanguage())
    },
  },
})

export type AuthClient = typeof authClient
